<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper" v-if="Object.keys(oppData).length">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <Form @submit="updateOpportunity" :validation-schema="schema">
            <div class="contact-head">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <ul class="contact-breadcrumb">
                    <li>
                      <button type="submit" class="custom-header-button"> <i class="ti ti-check"></i>
                        Save
                      </button>
                    </li>
                    <li>
                      <router-link
                        :to="{ path: '/crm/organisation-details', query: { ter_Id: terId, org_Id: org_id, opp_Id: formData.id, for: 'opportunities' } }">
                        <i class="ti ti-arrow-narrow-left"></i>
                        Organisation
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="isKanban
                        ? '/crm/meter-opportunities-kanban'
                        : '/crm/meter-opportunities-list'
                        ">
                        <i class="ti ti-arrow-narrow-left"></i>
                        List
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <send-loa v-if="opportunityData && Object.keys(opportunityData).length" :orgPersons="orgPersons"
              :opportunityData="opportunityData" :settingOptions="settingOptions" :key="loaRefreshKey"></send-loa>
            <div class="row">
              <div class="col-xl-12 col-lg-12">
                <div class="card">
                  <div class="card-body settings-form">
                    <div class="settings-sub-header">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <h4>
                            Meter Opportunity -
                            {{ formData.meter_opportunity_nr_auto }} | Edit
                          </h4>
                        </div>
                        <div class="col-6 text-end contact-head d-flex align-items-center justify-content-end">
                          <ul class="contact-breadcrumb mb-0 me-3">
                            <li class="mb-0" v-if="user.roles?.includes('company_admin')">
                                <router-link
                                    :to="{ path: '/crm/move', query: { entity_id: formData.id, 'entityType':'opportunity', kanban:isKanban} }"
                                    title="move"><i
                                        class="ti ti-arrows-move"></i>
                                </router-link>
                            </li>
                            <li class="mb-0" v-if="orgPersonsDetails">
                              <router-link
                                :to="{ path: '/crm/create-organisation', query: { org_Id: org_id, ter_Id: terId, opp_Id: formData.id, add: 'editOpp', for: 'opportunities' } }"
                                :title="'Edit' + ' ' + orgPersonsDetails.first_name + ' ' + orgPersonsDetails.last_name"><i
                                  class="ti ti-user-edit"></i> </router-link>
                            </li>
                            <li class="mb-0"
                              v-if="(companyType === 'partnership') || (companyType !== 'partnership' && orgPersons.length === 0) || (orgPersons.length !== 0 && companyType === 'partnership')">
                              <router-link title="Add Person" :to="{
                                path: '/crm/create-organisation',
                                query: { org_Id: org_id, opp_Id: formData.id, add: 'editOpp', for: 'opportunities' },
                              }"><i class="ti ti-user-plus"></i></router-link>
                            </li>
                          </ul>
                          <router-link v-if="quoteCount !== 0 && permissions.includes('Quoting')" :to="{
                            path: '/crm/quoted-price-list',
                            query: {
                              territory_id: terId,
                              org_Id: org_id,
                              opp_Id: oppId,
                            },
                          }" class="btn btn-teal me-2">
                            <i class="ion-pricetags"></i> Quoted
                            Prices</router-link>
                          <button v-if="permissions.includes('Quoting')" type="button" class="btn btn-teal me-2"
                            @click="getQuote">
                            Get quote
                          </button>

                          <button type="button" class="btn btn-teal me-2"
                            @click="deadLead(pipleline_type === 'closed_meter_op' ? 'Reopen' : 'DeadLead')">
                            {{ pipleline_type === 'closed_meter_op' ? 'Reopen' : 'Dead Lead' }}
                          </button>
                          <!-- v-if="formData.opp_type !== 'frs'" -->

                          <button type="button" class="btn btn-teal me-2" @click="createFRS">
                            Create FRS
                          </button>
                          <!-- v-if="formData.opp_type !== 'hot key'" -->
                          <button type="button" class="btn btn-teal me-2" @click="createHOTKEY">
                            HOT KEY
                          </button>
                          <button v-if="permissions.includes('Meter Opportunity Outbound')" type="button" class="btn btn-teal" @click="createOutbound">
                            Outbound
                          </button>
                        </div>
                      </div>
                      <div class="row organisation-details-section mt-2" v-if="Object.keys(org_details).length">
                        <div class="col-md-6">
                          <h4 class="d-flex align-items-center my-2">
                            <span class="text-teal" role="button" :title="orgPersonsDetails.email"
                              @click="handleEmailClick(orgPersonsDetails.email)"
                              style="font-size: 25px; margin-right: 7px;">@</span>
                            <router-link
                              :to="{ path: '/crm/organisation-details', query: { ter_Id: terId, opp_Id: formData.id, org_Id: org_id, for: 'opportunities' } }"
                              class="website me-2">
                              {{ org_details.name.split(' ').length > 1
                                ? (org_details.name.split(' ')[0][0] + org_details.name.split(' ')[1][0]).toUpperCase()
                                : org_details.name[0].toUpperCase()
                              }}
                            </router-link> {{ org_details.name }}
                            <!-- <a class="website me-2" :href="org_details.www">www</a>{{ org_details.name }} -->
                          </h4>
                           <p title="Address" v-if="complete_address">
                            {{
                              complete_address
                            }}
                          </p>
                          <p title="Contact Person Name" v-if="orgPersonsDetails">
                            {{ orgPersonsDetails.salutation + ' ' + orgPersonsDetails.first_name + ' ' +
                              orgPersonsDetails.last_name + ' ' + (orgPersonsDetails.job_title ? ` (
                            ${orgPersonsDetails.job_title} )` : '') }}
                          </p>
                          <p v-if="org_details.telephone">
                            T: <span title="Organisation telephone">{{
                              org_details.telephone }}</span>
                            <!-- <span title="Contact landline">{{
                                orgPersonsDetails.landline }}</span> -->
                            <!-- T: <span title="Contact landline">{{
                                orgPersonsDetails.landline }}</span> -->
                          </p>
                          <p title="Person Direct Line" v-if="orgPersonsDetails.direct_line">
                            D: {{ orgPersonsDetails.direct_line }}
                          </p>
                          <p title="Person Landline" v-if="orgPersonsDetails.landline">
                            L: {{ orgPersonsDetails.landline }}
                          </p>
                          <p title="Person mobile" v-if="orgPersonsDetails.mobile_telephone">
                            M: {{ orgPersonsDetails.mobile_telephone }}
                          </p>
                          <p title="Tps" v-if="
                            org_details?.tps
                          ">
                            TPS: {{
                              (org_details?.tps || "N/A")
                            }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <div class="form-wrap mb-0">
                            <label class="col-form-label">Comment </label>
                            <textarea class="form-control" rows="4" v-model="formData.comment"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pro-create">
                      <div class="row">
                        <template v-for="(field, index) in fields" :key="field.key">
                          <div :class="[
                            'draggable-field',
                            'form-group',
                            field.key === 'opp_type' || field.key === 'main_production_service' || field.key === 'referred_by' ? 'col' : 'col-md-2'
                          ]" draggable="true" @dragstart="dragStart($event, index)" @dragover="allowDrop"
                            @drop="dragEnd($event, index)">
                            <!-- Sales Responsible -->
                            <div class="form-wrap" v-if="field.key === 'sales_responsible'">
                              <label class="col-form-label">
                                {{ field.label }}
                                <span class="text-danger" v-if="field.required">*</span>
                              </label>
                              <Field as="select" name="sales_responsible" class="form-select"
                                v-model="formData.sales_responsible">
                                <option value="" v-if="saleResponsibleOptions.length > 1">-----Select-----</option>
                                <option v-for="res in saleResponsibleOptions" :key="res.id" :value="res.id">
                                  {{ res.name }}
                                </option>
                              </Field>
                              <ErrorMessage name="sales_responsible" class="text-danger" />
                              <span class="text-danger" v-if="isNotValid && !formData.sales_responsible">
                                Sales responsible is required
                              </span>
                            </div>

                            <!-- Referred By -->
                            <div class="form-wrap" v-if="field.key === 'referred_by'">
                              <label class="col-form-label">{{ field.label }}</label>
                              <Field as="select" name="referred_by" class="form-select" v-model="formData.referred_by">
                                <option value="">-----None-----</option>
                                <option v-for="res in saleResponsibleOptions" :key="res.id" :value="res.id">
                                  {{ res.name }}
                                </option>
                              </Field>
                            </div>

                            <!-- Opportunity Type -->
                            <!-- <div class="form-wrap" v-if="field.key === 'opp_type'">
                              <label class="col-form-label">{{ field.label }}</label>
                              <Field name="opp_type" as="input" type="text" class="form-control" disabled
                                v-model="formData.opp_type" />
                            </div> -->

                            <div class="form-wrap" v-if="field.key === 'opp_type'">
                              <label class="col-form-label">{{ field.label }}</label>
                              <Field as="select" name="opp_type" class="form-select py-2 disabledopp" v-model="formData.opp_type" disabled>
                                <option v-for="res in options.opp_type" :key="res.value" :value="res.value">
                                  {{ res.text }}
                                </option>
                              </Field>
                            </div>
                            <div class="form-wrap" v-if="field.key === 'created_from_contract_number'">
                              <label class="col-form-label">{{ field.label }}</label>
                              <Field as="input" type="text" name="created_from_contract_number" class="form-control"
                                v-model="formData.created_from_contract_number" @keypress="$utils.allowOnlyNumbers" />
                            </div>

                            <!-- Main Production Service -->
                            <div class="form-wrap" v-if="field.key === 'main_production_service'">
                              <label class="col-form-label">{{ field.label }}</label>
                              <Field as="select" name="main_production_service" class="form-select"
                                v-model="formData.main_production_service">
                                <option value="">-----Select-----</option>
                                <option v-for="res in options.op_product" :key="res.value" :value="res.value">
                                  {{ res.text }}
                                </option>
                              </Field>
                              <ErrorMessage name="main_production_service" class="text-danger" />
                              <span class="text-danger" v-if="isNotValid && !formData.main_production_service">
                                Main product/service is required
                              </span>
                            </div>

                            <!-- Pipeline Level -->
                            <div class="form-wrap" v-if="field.key === 'pipeline_level'">
                              <label class="col-form-label">{{ field.label }}</label>
                              <Field as="select" name="pipeline_level" class="form-select"
                                @change="fetchWinProb" v-model="formData.pipeline_level">
                                <option v-for="res in pipelineLevels" :key="res.id" :value="res.id">{{ res.name }}
                                </option>
                              </Field>
                            </div>

                            <!-- Status Update Date -->
                            <div class="form-wrap" v-if="field.key === 'pipeline_updated_at'">
                              <label class="col-form-label d-flex justify-content-between w-100">Pipeline Updated
                                Date</label>
                              <div class="icon-form">
                                <date-time-picker
                                  v-model="formData.pipeline_updated_at"
                                  text-input
                                  format="dd/MM/yyyy"
                                  auto-apply
                                  :enable-time-picker="false"
                                  :disabled=true
                                  :clearable=false
                                />
                              </div>
                            </div>

                          </div>
                        </template>
                      </div>
                      <div class="row mt-3">
                        <div class="col-md-3">
                          <div class="row">
                            <div class="col-12">
                              <div class="row">
                                <div class="col-8">
                                  <div class="form-wrap">
                                    <label class="col-form-label">Next update date</label>
                                    <div class="icon-form">
                                      <!-- v-if="isDateEditable" -->
                                      <date-picker text-input placeholder="" class="datetimepicker form-control"
                                        v-model="formData.next_update_latest_date
                                          " :editable="true" :clearable="true" :input-format="dateFormat"
                                        @update:modelValue="setTime" />
                                      <span class="form-icon"><i class="ti ti-calendar-check"></i></span>
                                    </div>
                                    <!-- <div class="row form-control mx-0 mb-0 disabled d-flex px-0" v-else>
                                      <div class="col-4">
                                        {{ formattedNextUpdateLatest }}
                                      </div>
                                      <div class="col-8 text-end">
                                        Locked to pipeline level
                                      </div>
                                    </div> -->
                                  </div>
                                </div>
                                <div class="col-4">
                                  <label class="col-form-label">Time</label>
                                  <div class="form-wrap icon-form">
                                    <!-- <a-space direction="vertical">
                                      <a-time-picker class="timepicker" v-model:value="timeValue" :minute-step="15"
                                        format="HH:mm" @change="handleTimeChange" @open-change="onPickerOpen" />
                                    </a-space> -->

                                    <a-space direction="vertical">
                                      <a-time-picker class="timepicker" v-model:value="timeValue" :minute-step="15"
                                        format="h:mm A" allow-clear use12-hours :disabled-hours="disableHours"
                                        @change="handleTimeChange" />
                                      <!-- <a-time-picker v-model:value="timeValue" use12-hours format="h:mm a" :minute-step="15" :disabled-hours="disableHours" @change="handleTimeChange"/> -->
                                    </a-space>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label d-flex justify-content-between w-100">Description</label>
                            <Field name="description" as="input" type="text" class="form-control"
                              v-model="formData.description" />
                            <!-- <ErrorMessage name="description" class="text-danger" /> -->
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label w-100">CED</label>
                            <div class="icon-form">
                              <Field name="contract_end_date" v-model="contract_end_date">
                                <date-time-picker
                                  v-model="formData.contract_end_date"
                                  text-input
                                  format="dd/MM/yyyy"
                                  auto-apply
                                  :enable-time-picker="false"
                                  :disabled=false
                                  :clearable=true
                                  @update:modelValue="clearEndDate"
                                />
                              </Field>
                            </div>
                            <ErrorMessage v-if="!isNotValid" name="contract_end_date" class="text-danger" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['contract_end_date'] &&
                              apiErrors['contract_end_date'].length
                            ">
                              {{ apiErrors["contract_end_date"][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-1">
                          <div class="form-wrap">
                            <label class="col-form-label">NIC</label>
                            <Field as="select" name="nic" class="form-select" v-model="formData.nic">
                              <option value="">-----Select-----</option>
                              <option v-for="res in yesNoOptions" :key="res" :value="res">
                                {{ res }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-1">
                          <div class="form-wrap">
                            <label class="col-form-label">COT</label>
                            <Field as="select" name="cot" class="form-select" v-model="formData.cot">
                              <option value="">-----Select-----</option>
                              <option v-for="res in yesNoOptions" :key="res" :value="res">
                                {{ res }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">COT Date</label>
                            <div class="icon-form">
                              <date-time-picker
                                v-model="formData.cot_date"
                                text-input
                                format="dd/MM/yyyy"
                                auto-apply
                                :enable-time-picker="false"
                                :disabled=false
                                :clearable=true
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row my-3">
                        <div class="col-4" v-if="isDateEditable">
                          <div class="form-wrap">
                            <div class="row mb-1">
                              <div class="col-2">Days:</div>
                              <div class="col add-cursor text-teal" @click="
                                addToDate(
                                  'next_update_latest_date',
                                  'days',
                                  day
                                )
                                " v-for="day in addDays" :key="day" :id="day" :title="getFutureDate(day, 'day')">
                                +{{ day }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-2">Months:</div>
                              <div class="col add-cursor text-teal" @click="
                                addToDate(
                                  'next_update_latest_date',
                                  'months',
                                  month
                                )
                                " v-for="month in addMonths" :key="month" :id="month"
                                :title="getFutureDate(month, 'month')">
                                +{{ month }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-6">
                          <div class="row mb-2">
                            <div class="col-md-6">
                              <div class="row align-items-center">
                                <div class="col-md-5">
                                  <label class="mb-0 text-muted">Number Of Dial</label>
                                </div>
                                <div class="col-md-7">
                                  <div class="row align-items-center">
                                    <div class="col-3 p-0">
                                      <input type="number" v-model="adjustDialValue" class="number_field text-center"
                                        readonly placeholder="0" />
                                    </div>
                                    <div class="col-2 p-0">
                                      <button @click="adjustDateDials(1, $event)" :class="{ 'disabled': !disabledDail }"
                                        class="btn btn-teal px-2 py-1"><i class="ti ti-plus"></i></button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="row align-items-center">
                                <div class="col-md-6">
                                  <label class="mb-0 text-muted">Number of No Answers</label>
                                </div>
                                <div class="col-md-6">
                                  <div class="row align-items-center">
                                    <div class="col-3 p-0">
                                      <input type="number" v-model="adjustValue" class="number_field text-center"
                                        readonly placeholder="0" />
                                    </div>
                                    <div class="col-2 p-0">
                                      <button @click="adjustDate(1, $event)" :class="{ 'disabled': !disabledAnswer }"
                                        class="btn btn-teal px-2 py-1"><i class="ti ti-plus"></i></button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-3" v-if="formData.main_production_service">
                          {{ formData.main_production_service }}
                          <div class="form-wrap">
                            <label class="col-form-label">
                              Current Supplier
                              <span class="text-danger">*</span>
                            </label>
                            <!-- Vee-Validate Field -->
                            <Field name="supplier_id" v-model="supplier_id">
                              <vue-select v-bind="field" :options="supplierOptions" v-model="formData.supplier_id"
                                placeholder="Select....." @select="myChangeEvent($event, 'current')" autocomplete="off"
                                autocorrect="off" autocapitalize="off" spellcheck="false" />
                            </Field>
                            <!-- Error Message -->
                            <ErrorMessage name="supplier_id" class="text-danger" />
                            <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.supplier_id === null || formData.supplier_id === '')
                            ">Current supplier is required</span>
                          </div>
                        </div>
                        <div class="col-md-2" v-if="formData.main_production_service?.toLowerCase() === 'elec'">
                          <div class="form-wrap">
                            <label class="col-form-label">Top Line
                              <span class="text-danger">*</span></label>
                            <Field name="mpan_top" as="input" type="text" class="form-control"
                              v-model="formData.mpan_top" />
                            <ErrorMessage v-if="!isNotValid" name="mpan_top" class="text-danger" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['mpan_top'] &&
                              apiErrors['mpan_top'].length
                            ">
                              {{ apiErrors["mpan_top"][0] }}
                            </span>
                            <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.mpan_top === null || formData.mpan_top === '')
                            ">MPAN Top is required</span>
                          </div>
                        </div>
                        <div class="col-md-3" v-if="formData.main_production_service?.toLowerCase() === 'elec'">
                          <div class="form-wrap">
                            <label class="col-form-label">Bottom Line
                              <i class="ti ti-search" v-if="permissions.includes('lookup')" style="cursor: pointer"
                                @click="
                                  electra_link_set ? searchPowwrMpan(formData.mpan_bottom) : openModal(formData.mpan_bottom, 'mpan')
                                  "></i>
                              <!-- openModal(formData.mpan_bottom, 'mpan') -->
                              <span class="text-danger">*</span></label>
                            <Field name="mpan_bottom" as="input" type="text" class="form-control"
                              v-model="formData.mpan_bottom" />
                            <ErrorMessage v-if="!isNotValid" name="mpan_bottom" class="text-danger" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['mpan_bottom'] &&
                              apiErrors['mpan_bottom'].length
                            ">
                              {{ apiErrors["mpan_bottom"][0] }}
                            </span>
                            <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.mpan_bottom === null || formData.mpan_bottom === '')
                            ">MPAN Bottom is required</span>
                          </div>
                        </div>
                        <div class="col-md-3" v-if="formData.main_production_service?.toLowerCase() === 'gas'">
                          <div class="form-wrap">
                            <label class="col-form-label">MPR NO. <i class="ti ti-search"
                                v-if="permissions.includes('lookup')" style="cursor: pointer" @click="
                                  openModal(formData.mpr, 'mprn')
                                  "></i>
                              <span class="text-danger">*</span></label>
                            <Field name="mpr" as="input" type="text" class="form-control" v-model="formData.mpr" />
                            <ErrorMessage v-if="!isNotValid" name="mpr" class="text-danger" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['mpr'] &&
                              apiErrors['mpr'].length
                            ">
                              {{ apiErrors["mpr"][0] }}
                            </span>
                            <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.mpr === null || formData.mpr === '')
                            ">MPR No. is required</span>
                          </div>
                        </div>
                        <div class="col-md-2"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && (supplierName !== 'Pozitive Energy' || supplierName === null)">
                          <!-- || formData.main_production_service?.toLowerCase() === 'gas' -->
                          <div class="form-wrap">
                            <label class="col-form-label">Consumption</label>
                            <!-- <label class="col-form-label">Day/All</label> -->
                            <input type="text" class="form-control" v-model="formData.quoted_annual_consumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['quoted_annual_consumption'] &&
                              apiErrors['quoted_annual_consumption'].length
                            ">
                              {{ apiErrors["quoted_annual_consumption"][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-2" v-if="formData.main_production_service?.toLowerCase() === 'elec'">
                          <div class="form-wrap">
                            <label class="col-form-label">KVA (IF 00)</label>
                            <input type="text" class="form-control" v-model="formData.forecast_commission.kva" />
                          </div>
                        </div>

                        <div class="col-md-2"
                          v-if="(formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy')">
                        </div>

                        <div class="col-md-2"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                          <div class="form-wrap">
                            <label class="col-form-label">Day/All</label>
                            <input type="text" class="form-control"
                              v-model="formData.forecast_commission.day_consumption" @change="totalConsumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['day_consumption'] &&
                              apiErrors['day_consumption'].length
                            ">
                              {{ apiErrors["day_consumption"][0] }}
                            </span>
                          </div>
                        </div>

                        <div class="col-md-1"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                          <div class="form-wrap">
                            <label class="col-form-label">Uplift Day/ALL</label>
                            <input type="text" class="form-control" v-model="formData.forecast_commission.day_uplift"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['day_uplift'] &&
                              apiErrors['day_uplift'].length
                            ">
                              {{ apiErrors["day_uplift"][0] }}
                            </span>
                          </div>
                        </div>

                        <div class="col-md-2"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                          <div class="form-wrap">
                            <label class="col-form-label">Night</label>
                            <input type="text" class="form-control"
                              v-model="formData.forecast_commission.night_consumption" @change="totalConsumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['night_consumption'] &&
                              apiErrors['night_consumption'].length
                            ">
                              {{ apiErrors["night_consumption"][0] }}
                            </span>
                          </div>
                        </div>

                        <div class="col-md-1"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                          <div class="form-wrap">
                            <label class="col-form-label">Uplift Night</label>
                            <input type="text" class="form-control" v-model="formData.forecast_commission.night_uplift"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['night_uplift'] &&
                              apiErrors['night_uplift'].length
                            ">
                              {{ apiErrors["night_uplift"][0] }}
                            </span>
                          </div>
                        </div>

                        <div class="col-md-2"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                          <div class="form-wrap">
                            <label class="col-form-label">Evening/Weekend</label>
                            <input type="text" class="form-control"
                              v-model="formData.forecast_commission.weekend_consumption" @change="totalConsumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['weekend_consumption'] &&
                              apiErrors['weekend_consumption'].length
                            ">
                              {{ apiErrors["weekend_consumption"][0] }}
                            </span>
                          </div>
                        </div>

                        <div class="col-md-2"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                          <div class="form-wrap">
                            <label class="col-form-label">Uplift Evening/Weekend</label>
                            <input type="text" class="form-control"
                              v-model="formData.forecast_commission.weekend_uplift"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['weekend_uplift'] &&
                              apiErrors['weekend_uplift'].length
                            ">
                              {{ apiErrors["weekend_uplift"][0] }}
                            </span>
                          </div>
                        </div>

                        <div class="col-md-2"
                          v-if="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                          <div class="form-wrap">
                            <label class="col-form-label">Uplift Standing charge</label>
                            <input type="text" class="form-control"
                              v-model="formData.forecast_commission.uplift_standing_charge"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['uplift_standing_charge'] &&
                              apiErrors['uplift_standing_charge'].length
                            ">
                              {{ apiErrors["uplift_standing_charge"][0] }}
                            </span>
                          </div>
                        </div>

                        <div class="col-md-3" v-if="formData.main_production_service?.toLowerCase() === 'water'">
                          <div class="form-wrap">
                            <label class="col-form-label">SPID</label>
                            <Field name="spid" as="input" type="text" class="form-control" v-model="formData.spid" />
                            <!-- <ErrorMessage name="spid" class="text-danger" /> -->
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['spid'] &&
                              apiErrors['spid'].length
                            ">
                              {{ apiErrors["spid"][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3" v-if="formData.main_production_service?.toLowerCase() === 'water'">
                          <div class="form-wrap">
                            <label class="col-form-label">Water Consumption</label>
                            <input type="text" class="form-control" v-model="formData.water_consumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['water_consumption'] &&
                              apiErrors['water_consumption'].length
                            ">
                              {{ apiErrors["water_consumption"][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3" v-if="formData.main_production_service?.toLowerCase() === 'water'">
                          <div class="form-wrap">
                            <label class="col-form-label">Waste Consumption</label>
                            <input type="text" class="form-control" v-model="formData.waste_consumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['waste_consumption'] &&
                              apiErrors['waste_consumption'].length
                            ">
                              {{ apiErrors["waste_consumption"][0] }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row align-items-center mb-3">
                        <div class="col-md-4">
                          <div class="form-wrap">
                            <label class="col-form-label d-flex w-100 justify-content-between"><span>Sales contact
                                <span class="text-danger">*</span></span>
                              <router-link
                                :to="{ path: '/crm/create-organisation', query: { org_Id: org_id, opp_Id: oppId, add: 'editOpp', for: 'opportunities' } }"
                                class="btn text-teal text-decoration-underline p-0"
                                v-if="(companyType === 'partnership') || (companyType !== 'partnership' && orgPersons.length === 0) || (orgPersons.length !== 0 && companyType === 'partnership')">
                                Add Sales Contact
                              </router-link>
                            </label>
                            <Field as="select" name="sales_contact" class="form-select"
                              v-model="formData.sales_contact">
                              <option value="">-----Select-----</option>
                              <option v-for="res in orgPersons" :key="res.id" :value="res.id">
                                {{ res.name }}
                              </option>
                              <option v-if="orgPersons.length === 0" disabled>
                                No contacts available
                              </option>
                            </Field>
                            <ErrorMessage name="sales_contact" class="text-danger" />
                            <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.sales_contact === null || formData.sales_contact === '')
                            ">Sales contact is required</span>
                          </div>
                        </div>
                        <div class="col-md-4 text-center pt-2">
                          <label class="me-5">
                            <input type="checkbox" :checked="selectedOption === 'supply'"
                              @change="selectOption('supply')" class="checkbox-size" />
                            Same as Supply Address
                          </label>
                          <label>
                            <input type="checkbox" :checked="selectedOption === 'organisation'"
                              @change="selectOption('organisation')" class="checkbox-size" />
                            Same as Company Address
                          </label>
                        </div>
                        <div class="col-md-4">
                          <div class="form-wrap">
                            <label class="col-form-label">New Supplier </label>
                            <vue-select :options="supplierOptions" :key="supplierOptions.id" :id="supplierOptions.id"
                              v-model="formData.new_supplier_id" placeholder="Search Supplier....."
                              @select="myChangeEvent($event, 'new')" autocomplete="off" autocorrect="off"
                              autocapitalize="off" spellcheck="false" />
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <div class="row">
                            <div class="col-md-12 mb-2">
                              <h6 class="text-primary">Supply Address</h6>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Building Name
                                  <span class="text-danger">*</span></label>
                                <Field name="building_name" as="input" type="text" class="form-control"
                                  v-model="formData.supply_address.building_name" />
                                <ErrorMessage name="building_name" class="text-danger" />
                                <span class="text-danger" v-if="
                                  isNotValid &&
                                  (formData.supply_address.building_name === null || formData.supply_address.building_name === '')
                                ">Building Name is required</span>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Street <span class="text-danger">*</span></label>
                                <Field name="street" as="input" type="text" class="form-control"
                                  v-model="formData.supply_address.street" />
                                <ErrorMessage name="street" class="text-danger" />
                                <span class="text-danger" v-if="
                                  isNotValid &&
                                  (formData.supply_address.street === null || formData.supply_address.street === '')
                                ">Street is required</span>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">City <span class="text-danger">*</span></label>
                                <Field name="city" as="input" type="text" class="form-control"
                                  v-model="formData.supply_address.city" />
                                <ErrorMessage name="city" class="text-danger" />
                                <span class="text-danger" v-if="
                                  isNotValid &&
                                  (formData.supply_address.city === null || formData.supply_address.city === '')
                                ">City is required</span>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">County <span class="text-danger">*</span></label>
                                <Field name="county" as="input" type="text" class="form-control"
                                  v-model="formData.supply_address.county" />
                                <ErrorMessage name="county" class="text-danger" />
                                <span class="text-danger" v-if="
                                  isNotValid &&
                                  (formData.supply_address.county === null || formData.supply_address.county === '')
                                ">County is required</span>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Postcode
                                  <i class="ti ti-search" v-if="permissions.includes('lookup')" style="cursor: pointer"
                                    @click="openModal(formData.supply_address.postcode, 'postcode')"></i>
                                  <span class="text-danger">*</span></label>
                                <Field name="postcode" as="input" type="text" class="form-control"
                                  v-model="formData.supply_address.postcode" />
                                <ErrorMessage name="postcode" class="text-danger" />
                                <span class="text-danger" v-if="
                                  isNotValid &&
                                  formData.supply_address.postcode === null
                                ">Postcode is required</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="row">
                            <div class="col-md-12 mb-2">
                              <h6 class="text-primary">Billing Address</h6>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Building Name</label>
                                <Field name="address_line_1" as="input" type="text" class="form-control"
                                  v-model="formData.billing_address.address_line_1" @change="handleChange" />
                                <ErrorMessage name="address_line_1" class="text-danger" />
                                <!-- <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.billing_address.address_line_1 === null || formData.billing_address.address_line_1 === '')
                            ">Address Line 1 is required</span> -->
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Street </label>
                                <Field name="address_line_2" as="input" type="text" class="form-control"
                                  v-model="formData.billing_address.address_line_2" @change="handleChange" />
                                <ErrorMessage name="address_line_2" class="text-danger" />
                                <!-- <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.billing_address.address_line_2 === null || formData.billing_address.address_line_2 === '')
                            ">Address Line 2 is required</span> -->
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">City</label>
                                <Field name="address_line_3" as="input" type="text" class="form-control"
                                  v-model="formData.billing_address.address_line_3" @change="handleChange" />
                                <ErrorMessage name="address_line_3" class="text-danger" />
                                <!-- <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.billing_address.address_line_3 === null || formData.billing_address.address_line_3 === '')
                            ">Address Line 3 is required</span> -->
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">County</label>
                                <Field name="address_line_4" as="input" type="text" class="form-control"
                                  v-model="formData.billing_address.address_line_4" @change="handleChange" />
                                <ErrorMessage name="county" class="text-danger" />
                                <!-- <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.billing_address.address_line_4 === null || formData.billing_address.address_line_4 === '')
                            ">Address Line 4 is required</span> -->
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Postcode</label>
                                <Field name="billing_postcode" as="input" type="text" class="form-control"
                                  v-model="formData.billing_address.postcode" @change="handleChange" />
                                <ErrorMessage name="billing_postcode" class="text-danger" />
                                <!-- <span class="text-danger" v-if="
                              isNotValid &&
                              (formData.billing_address.postcode === null || formData.billing_address.postcode === '')
                            ">Postcode is required</span> -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="form-wrap">
                                <label class="col-form-label">Start Date</label>
                                <div class="icon-form">
                                  <Field name="contract_start_date" v-model="contract_start_date">
                                    <date-time-picker
                                      v-model="formData.contract_start_date"
                                      text-input
                                      format="dd/MM/yyyy"
                                      auto-apply
                                      :enable-time-picker="false"
                                      :disabled=true
                                      :clearable=false
                                    />
                                  </Field>

                                </div>
                                <ErrorMessage name="contract_start_date" class="text-danger" />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-wrap">
                                <label class="col-form-label">Term</label>
                                <Field name="term" as="input" type="text" class="form-control"
                                  v-model="formData.term" />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-8">
                              <div class="form-wrap">
                                <label class="col-form-label">Sale Type</label>
                                <Field as="select" name="sale_type" class="form-select" v-model="formData.sale_type">
                                  <option value="">-----Select-----</option>
                                  <option v-for="res in options.op_sales_type" :key="res.value" :value="res.value">
                                    {{ res.text }}
                                  </option>
                                </Field>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-wrap">
                                <label class="col-form-label">U4B Uplift
                                </label>
                                <Field as="input" name="u4b_uplift" type="text" class="form-control" v-model="formData.forecast_commission.u4b_uplift
                                  " @keypress="$utils.allowOnlyNumbers" @change="handleU4vUplift" />
                                <ErrorMessage name="u4b_uplift" class="text-danger" />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Forecast Annual Consumption
                                  <span class="text-danger">*</span></label>
                                <Field as="input" name="sc_forecast_or_amended_annual_consumption" type="text"
                                  class="form-control" v-model="formData.forecast_commission
                                    .sc_forecast_or_amended_annual_consumption
                                    " @keypress="$utils.allowOnlyNumbers"
                                  :disabled="formData.main_production_service?.toLowerCase() === 'elec' && pipleline_type === 'contract_won' && ['sales_representative'].some(role => user.roles.includes(role))" />
                                <!-- :disabled="formData.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'" -->
                                <ErrorMessage name="sc_forecast_or_amended_annual_consumption" class="text-danger" />
                                <span class="text-danger" v-if="
                                  isNotValid &&
                                  (formData.forecast_commission.sc_forecast_or_amended_annual_consumption === '0.00' || formData.forecast_commission.sc_forecast_or_amended_annual_consumption === '')
                                ">SC Forecast or Amended Annual Consumption is required</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">SC Forecast Commission</label>
                                <input name="sc_corecast_or_amended_total_commission" type="text" class="form-control"
                                  v-model="formattedData.sc_corecast_or_amended_total_commission
                                    " @blur="
                                      updateFormData(
                                        'sc_corecast_or_amended_total_commission',
                                        formattedData.sc_corecast_or_amended_total_commission
                                      )
                                      " @focus="
                                        formattedData.sc_corecast_or_amended_total_commission =
                                        formatNumber(
                                          formData.forecast_commission
                                            .sc_corecast_or_amended_total_commission
                                        )
                                        " @keypress="$utils.allowOnlyNumbers" />
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <label class="col-form-label">Consumption Source</label>
                                <Field as="select" name="consumption_source" class="form-select"
                                  v-model="formData.consumption_source">
                                  <option value="">-----Select-----</option>
                                  <option v-for="res in options.opp_consumption_source" :key="res.value"
                                    :value="res.value">
                                    {{ res.text }}
                                  </option>
                                </Field>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <label class="col-form-label">Quotation
                                  <router-link :to="{ path: '/crm/quotes', query: { opp_Id: oppId } }" class="ms-1"> <i
                                      class="ti ti-edit"></i>
                                  </router-link>
                                </label>
                                <input type="text" class="form-control" v-model="formData.quotation" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-4">
                        <div class="form-wrap mb-0" style="border: 1px solid #e1e1e1">
                          <h4 class="p-2">Logs</h4>
                          <p class="col-form-label p-2" style="background-color: #eff1f0">
                            Add log entry
                          </p>
                          <textarea class="form-control" rows="3" v-model="formData.content"></textarea>
                        </div>
                        <div class="row my-3">
                          <div class="col-md-12">
                            <div class="form-wrap mb-0 shadow" style="border: 1px solid #e1e1e1">
                              <p class="col-form-label p-2" style="background-color: #eff1f0">
                                Logs
                              </p>
                              <div class='logs_Section resizable'>
                                <div class="row" v-for="log in logs">
                                  <div class="col-12">
                                    <p class="p-2" style="border-bottom: 1px solid #e1e1e1;white-space: pre-wrap;">
                                      {{ log.content }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-wrap mb-0 shadow" style="border: 1px solid #e1e1e1">
                          <h4 class="p-2" style="background-color: #eff1f0">
                            Documents
                          </h4>
                          <div>
                            <div class="row">
                              <div class="col-12">
                                <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave"
                                  @drop="drop">
                                  <input type="file" multiple name="file" id="fileInput" class="hidden-input"
                                    @change="onChange" ref="fileInput" />

                                  <label for="fileInput" class="file-label">
                                    <div v-if="isDragging">Release to drop files here.</div>
                                    <div v-else>Choose a file or drop it here</div>
                                    <p style="font-size: 10px;">
                                      The file must be a type of : pdf, doc, docx, png, jpeg, jpg, mp3, mp4, flac,
                                      wav.
                                    </p>
                                  </label>
                                </div>
                                <div class="table-responsive add-x-scroll">
                                  <table class="table table-bordered logs_Section">
                                    <tbody>
                                      <tr v-for="file in displayedFiles" :key="file.id">
                                        <td>
                                          <a href="javascript:void(0);" title="Download file"
                                            @click="downloadFile(file)"
                                            class="btn documnet-btn btn-primary export_btn p-1">
                                            <i class="ti ti-download icon-size"></i>
                                          </a>
                                        </td>
                                        <td>
                                          <i class="ti ti-x icon-size" @click="deleteFile(file.id)"
                                            style="color: red;"></i>
                                        </td>
                                        <td class="truncate-doc-name" v-if="!renameStates[file.id]">
                                          <a href="#" @click="viewFile(file.file_path)" :title="file.doc_name">
                                            {{ file.doc_name.length > 20 ? file.doc_name.substr(0, 15) + '....' :
                                              file.doc_name }}
                                          </a>
                                          <span class="ms-2 cursor-pointer" title="Rename" style="font-size: 16px;"
                                            @click="showRenameField(file.doc_name, file.id)">
                                            <i class="ti ti-edit"></i>
                                          </span>
                                        </td>

                                        <td class="truncate-doc-name" v-if="renameStates[file.id]">
                                          <input type="text" class="border-0 border-bottom ms-2"
                                            v-model="renameInputs[file.id]">
                                          <span class="mx-2 cursor-pointer" @click="cancelRename(file.id)">
                                            <i class="ti-close"></i>
                                          </span>
                                          <span v-if="renameInputs[file.id]" class="me-2 cursor-pointer"
                                            @click="renameDoc(file.id, file.doc_type)">
                                            <i class="ti ti-check" style="font-size: 18px;"></i>
                                          </span>
                                        </td>
                                        <td class="d-flex flex-column align-items-center">
                                          <span>{{ formatDate(file.created_at) }}</span>
                                          <span>{{ file.file_size + file.file_size_unit }}</span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div v-if="fileData.length > 4" class="col-12">
                                <p class="p-2" @click="toggleViewMore" style="cursor: pointer; color: blue;">
                                  {{ showAllFiles ? "View less ..." : "View more ..." }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="submit-button mt-4">
                      <div class="row">
                        <div class="col-6">
                          <button type="button" class="btn btn-light" @click="handleCancel">
                            Back
                          </button>
                        </div>
                        <div class="col-6 text-end">
                          <button type="submit" class="btn btn-primary">
                            Save
                          </button>
                          <button v-if="permissions.includes('Quoting')" type="button" class="btn btn-teal"
                            @click="getQuote">
                            Get quote
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-else-if="showFallback">
    <div class="col-md-12">
      <no-data-found />
    </div>
  </div>
  <look-up-modal :fromOpp="true" :formData="formData" :isVisible="isModalVisible" :searchPostcode="selectedPostcode"
    :selectedLabel="selectedLabel" :supplierOptions="supplierOptions" @close="closeModal"></look-up-modal>

  <electric-look-up-modal :fromOpp="true" :formData="formData" :isVisible="isVisible" :electricLinkData="electricData"
    :isPowwrData="isPowwrData" :electricDataRawPowwr="electricDataRawPowwr"
    :supplierOptions="supplierOptions" @close="closeModal"></electric-look-up-modal>

  <create-frs :formData="formData" :supplierOptions="supplierOptions" :oppData="oppData"
    @created="refreshOpportunityAfterCreate"></create-frs>

  <hotKey :formData="formData" :supplierOptions="supplierOptions" :oppData="oppData"
    :saleResponsibleOptions="saleResponsibleOptions" @created="refreshOpportunityAfterCreate" />

  <outbound :formData="formData" :saleResponsibleOptions="saleResponsibleOptions"
    @created="refreshOpportunityAfterCreate" />



  <div ref="closedMeterOpp" class="modal fade" id="confirm_opp_modal" tabindex="-1" role="dialog"
    aria-labelledby="closedMeterOppLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="d-flex justify-content-between">
          <h4 class="">{{ pipleline_type === 'closed_meter_op' ? 'Reopen' : 'Lost meter opportunity' }}</h4>
          <div class="modal-header border-0 m-0 justify-content-end">
            <button class="btn-close" id="close-btn" data-bs-dismiss="modal" aria-label="Close" @click="cancel_change">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <div class="modal-body confirm">
          <div v-if="pipleline_type === 'closed_meter_op'">
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label">Pipeline Level</label>
                <Field as="select" name="pipeline_level" class="form-select" v-model="formData.pipeline_level">
                  <option v-for="res in pipelineLevelsForOpen" :key="res.id" :value="res.id">
                    {{ res.name }}
                  </option>
                </Field>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label">Comment </label>
                <textarea class="form-control" rows="4" v-model="formData.comment"></textarea>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label">Reason</label>
                <Field as="select" name="reason" class="form-select" v-model="formData.reason">
                  <option value="">-----Select-----</option>
                  <option v-for="res in options.op_dead_lead_reasons?.filter(r => r.text !== 'future frs created')"
                    :key="res.value" :value="res.value">
                    {{ res.text }}
                  </option>
                </Field>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label">Competitor</label>
                <Field as="select" name="competitor" class="form-select" v-model="formData.competitor">
                  <option value="">-----Select-----</option>
                  <option v-for="res in options.op_competitor" :key="res.value" :value="res.value">
                    {{ res.text }}
                  </option>
                </Field>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-wrap">
                <label class="col-form-label">Explanation</label>
                <input type="text" class="form-control" v-model="formData.explanation" />
                <span class="text-danger" v-if="
                  apiErrors &&
                  apiErrors['explanation'] &&
                  apiErrors['explanation'].length
                ">
                  {{ apiErrors["explanation"][0] }}
                </span>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary confirm-btn me-2"
              @click="confirm_change(pipleline_type === 'closed_meter_op' ? 'Reopen' : 'DeadLead')">
              Confirm
            </button>
            <button class="btn btn-outline-secondary cancel-btn" @click="cancel_change">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="isShowEmailPopup" class="modal-backdrop">
    <div class="modal-dialog bg-white">
      <div class="modal-content">
        <div class="modal-header">
          <h4>Enter Sales Contact Email</h4>
          <button class="close-btn" @click="cancel_email_change">×</button>
        </div>
        <div class="modal-body">
          <div>
            <!-- <label>Email</label> -->
            <input type="email" v-model="email" class="form-control" placeholder="Enter email" />
            <div class="modal-actions">
              <button class="btn btn-primary me-2" @click="confirm_email_change">
                Confirm
              </button>
              <button class="btn btn-secondary" @click="cancel_email_change">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <leave-confirmation-modal
    :show="showLeaveModal"
    @confirm="confirmLeave"
    @cancel="cancelLeave"
    /> -->
</template>

<script>
import { ref, onMounted, watch, computed, onUnmounted, watchEffect } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { changeFormate } from '../../../../util'
import apiClient from "@/axios";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
const currentDateTwo = ref(new Date());
import dayjs from 'dayjs';
import { Modal } from 'bootstrap';
import { message } from 'ant-design-vue';
import isEqual from 'lodash.isequal';
import hotKey from "@/views/layouts/hotKey.vue";
import outbound from "@/views/layouts/outbound.vue";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    hotKey,
    outbound
  },
  methods: {
    openTimePicker() {
      this.$refs.timeInput.showPicker();
    },
  },
  data() {
    return {
      startdate: currentDate,
      startdateOne: currentDateOne,
      startdateTwo: currentDateTwo,
      dateFormat: "dd/MM/yyyy",
      yesNoOptions: ["YES", "NO"],
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const org_id = ref(null);
    const isDateEditable = ref(true);
    const pipleline_type = ref('');
    // const isShowWon = ref(false);
    const oppNumber = ref(route.params.id || null);
    const oppId = ref(null);
    const terId = ref(null)
    // const isValidate = ref(0);
    const showFallback = ref(false);
    const productFor = ref("");
    const companyType = ref(null);
    const isNotValid = ref(false);
    const quoteCount = ref(0);
    const isKanban = ref(false);
    const supplierOptions = ref([]);
    const isTps = ref(false)
    const isDragging = ref(false); // Reactive state for drag status
    const files = ref([]); // Reactive state for file storage
    const fileInput = ref(null); // Ref for file input element
    const fileData = ref([])
    const supplier_id = ref()
    const contract_start_date = ref();
    const contract_end_date = ref();
    const logs = ref([]);
    const org_details = ref({});
    const orgPersonsDetails = ref({});
    const complete_address = ref('');
    // const addDays = ref(["0", "1", "2", "3", "4", "5", "6", "7", "14", "21"]);

    const showRename = ref(false)
    const renameInput = ref("")
    const fileId = ref("")
    const currtDate = ref(new Date())
    const loaRefreshKey = ref(0);

    // const originalForm = ref({});
    // const hasUnsavedChanges = ref(false);
    // const showLeaveModal = ref(false);
    // let pendingRoute = null; // ✅ define this

    function isWeekend(date) {
      const day = date.getDay()
      return day === 0 || day === 6
    }

    // Get valid day offsets (excluding weekends)
    function getValidDayOffsets() {
      const today = new Date()
      const dayOffsets = [0, 1, 2, 3, 4, 5, 6, 7, 14, 21]

      return dayOffsets.filter(offset => {
        const date = new Date(today)
        date.setDate(date.getDate() + offset)
        return !isWeekend(date)
      })
    }

    const email = ref('');
    const isShowEmailPopup = ref(false);


    const confirm_email_change = async () => {
      try {
        const payload = {
          id: formData.value.sales_contact,
          email: email.value
        }
        const response = await store.dispatch("opportunity/updatePerson", payload);
        if (response?.status) {
          const totalPersons = await store.dispatch('opportunity/fetchPersons', org_id.value);
          orgPersons.value = totalPersons;
          isShowEmailPopup.value = false;
        }
      } catch (error) {
        console.error(error)
      }
    };

    const cancel_email_change = () => {
      email.value = ''
      formData.value.pipeline_level = oppData.value.pipeline_level
      pipeline_type.value = oppData.value.pipeline_type
      isShowEmailPopup.value = false
    };

    // Get valid month offsets (excluding weekends)
    // function getValidMonthOffsets() {
    //   const today = new Date()
    //   const monthOffsets = [1, 2, 3, 4, 5, 6, 9, 12]

    //   return monthOffsets.filter(offset => {
    //     const date = new Date(today)
    //     date.setMonth(date.getMonth() + offset)
    //     return !isWeekend(date)
    //   })
    // }

    // Reactive refs
    const addDays = ref(getValidDayOffsets())
    // const validMonths = ref(getValidMonthOffsets())
    const addMonths = ref(["1", "2", "3", "4", "5", "6", "9", "12"]);

    const selectedPostcode = ref("");
    const selectedLabel = ref("");
    const isModalVisible = ref(false);
    const isVisible = ref(false)
    // const permissions = ref(JSON.parse(localStorage.getItem('user')).permissions || [])
    const permissions = computed(() => {
      const user = store.getters['auth/user']
      return user.permissions;
    })
    const user = computed(() => store.getters['auth/user']);
    const selectedOption = ref()
    let billingAddress;

    const piplelineType = ref(0);
    const pipeline_type = ref()

    const timeValue = ref(dayjs('00:00', 'HH:mm'));

    const oppData = ref({});
    // const showFRS = ref(null)
    const electricData = ref({})
    const electricDataRawPowwr = ref(null)
    const isPowwrData = ref(false)

    if (route.query.kanban) {
      isKanban.value = true;
    }

    const apiErrors = ref([])
    const settingOptions = ref({})

    const adjustValue = ref(0);
    const adjustDialValue = ref(0);

    const last_dialed_at = ref(null)
    const last_no_answer_at = ref(null)

    const disabledDail = ref(false)
    const disabledAnswer = ref(false)
    // const created_updated = ref('')

    let intervalId;
    const closedMeterOpp = ref()
    const showAllFiles = ref(false);

    const displayedFiles = computed(() => (showAllFiles.value ? fileData.value : fileData.value.slice(0, 4)));

    const supplierName = computed(() => {
      const supplier = supplierOptions.value.find(item => item.id === formData.value.new_supplier_id)
      return supplier?.text || null;
    })

    const toggleViewMore = () => {
      showAllFiles.value = !showAllFiles.value;
    };
    const pipelineLevels = computed(
      () => {
        const data = store.getters["opportunity/getPipelineLevels"]
        if (pipleline_type.value !== "closed_meter_op") {
          return data.filter(item => item.name !== 'Closed Meter Op');
        } else {
          return data;
        }
      }
    );

    const pipelineLevelsForOpen = computed(
      () => store.getters["opportunity/getPipelineLevels"]
    );

    const options = computed(
      () => store.getters["opportunity/getoppDropdowns"]
    );
    const electra_link_set = computed(
      () => store.getters["opportunity/getElectraLink"]
    );
    const opportunityData = computed(
      () => store.getters["opportunity/getoppViewData"]
    );
    const orgPersons = ref([]);
    const saleResponsibleOptions = computed(
      () => store.getters["organisation/getresUsersOptions"]
    );
    // const cmResponsibleOptions = computed(
    //   () => store.getters["opportunity/getCmResponsibles"]
    // );
    // Computed property to format the date
    const formattedNextUpdateLatest = computed(() => {
      const date = new Date(formData.value.next_update_latest_date);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    });
    const openModal = (code, label) => {
      selectedPostcode.value = code; // Assign the clicked value to selectedPostcode
      selectedLabel.value = label;
      isModalVisible.value = true;
    };
    const closeModal = () => {
      isModalVisible.value = false;
      isVisible.value = false;
      isPowwrData.value = false;
      electricDataRawPowwr.value = null;
    };
    const formattedData = computed(() => {
      const { forecast_commission } = formData.value;
      return {
        // cancelled_commission: formatNumber(
        //   forecast_commission.cancelled_commission
        // ),
        sc_corecast_or_amended_total_commission:
          forecast_commission.sc_corecast_or_amended_total_commission
        ,
        // sc_forecast_or_amended_first_payment: formatNumber(
        //   forecast_commission.sc_forecast_or_amended_first_payment
        // ),
        // sc_forecast_or_amended_residual_payment: formatNumber(
        //   forecast_commission.sc_forecast_or_amended_residual_payment
        // ),
        // u4b_uplift: formatNumber(forecast_commission.u4b_uplift),
        // final_contract_consumption: formatNumber(
        //   forecast_commission.final_contract_consumption
        // ),
        // failed_credit: formatNumber(forecast_commission.failed_credit),
        // final_contract_commission: formatNumber(
        //   forecast_commission.final_contract_commission
        // ),
        // actual_first_payment: formatNumber(
        //   forecast_commission.actual_first_payment
        // ),
        // actual_residual_payment: formatNumber(
        //   forecast_commission.actual_residual_payment
        // ),
        // forecast_first_payment_amount: formatNumber(
        //   forecast_commission.forecast_first_payment_amount
        // ),
      };
    });
    // Watch for changes to formatted data and update the raw data
    const updateFormData = (key, value) => {
      formData.value.forecast_commission[key] = removeFormatting(value);
    };

    const schema = Yup.object().shape({
      pipeline_level: Yup.string().required("Pipeline level is required"),
      main_production_service: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Main Product Service is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      // mpr: Yup.string().when("main_production_service", {
      //   is: "Gas",
      //   then: (schema) => schema.required("MPR No. is required"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      // mpan_top: Yup.string().when("main_production_service", {
      //   is: "Elec",
      //   then: (schema) => schema.required("MPAN top is required"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      // mpan_bottom: Yup.string().when("main_production_service", {
      //   is: "Elec",
      //   then: (schema) => schema.required("MPAN bottom is required"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),

      supplier_id: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Current Supplier is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      contract_start_date: Yup.string().notRequired(),

      contract_end_date: Yup.mixed().notRequired(),

      building_name: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Building name is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      street: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Street is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      city: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("City is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      county: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("County is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      sales_contact: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Sales contact is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      postcode: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Postcode is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      sales_responsible: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Sales Responsible is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      sc_forecast_or_amended_annual_consumption: Yup.number()
        .typeError("Forecast Annual Consumption must be a number")
        .when("pipeline_level", {
          is: (pipeline_level) => {
            const matchedLevel = pipelineLevels.value.find(
              (item) => item.id === pipeline_level
            );
            return matchedLevel && matchedLevel.form_validation === 1;
          },
          then: (schema) =>
            schema
              .required("Amended Annual Consumption is required")
              .min(0.1, "Annual consumption must be greater than 0"),
          otherwise: (schema) => schema.notRequired(),
        }),
      u4b_uplift: Yup.string().when("pipeline_level", {
        is: (pipeline_level) => {
          // Find the corresponding value in pipelineLevels
          const matchedLevel = pipelineLevels.value.find(
            (item) => item.id === pipeline_level
          );
          return matchedLevel && matchedLevel.form_validation === 1;
        },
        then: (schema) => schema.required("Main Product Service is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    });
    const formData = ref({
      id: null,
      is_valid: 0,
      pipeline_level: null, //int id
      opp_type: null,
      created_from_contract_number: null,
      water_consumption: null,
      waste_consumption: null,
      term: null,
      consumption_source: null,
      next_update_latest_date: null, //date
      next_update_latest_time: "00:00:00",
      date_of_sale: null, //date
      contract_end_date: null, //date
      mpr: null, //String input
      mpan_top: null, //String input
      mpan_bottom: null, //String input
      supplier_id: null, //int id
      spid: "", //string input
      description: "", //string input
      sales_contact: null, //int id
      quoted_annual_consumption: null, //int input number
      quotation: "", //string input
      meter_opportunity_nr_auto: null, //int input number
      main_production_service: null, //string input
      sales_responsible: null, //int id
      referred_by: null, //int id
      new_supplier_id: null, //int id
      contract_start_date: null, //date
      sale_type: "", //string input
      cot: "", //string
      cot_date: null, //date
      nic: "", //string
      tps: "",
      pipeline_updated_at: null,
      supply_address: {
        building_name: null, //string input
        street: null, //string input
        city: null, //string input
        county: null, //string input
        postcode: null, //string input
        comment: null, //string input
        content: null, //string input
      },
      billing_address: {
        address_line_1: "",
        address_line_2: "",
        address_line_3: "",
        address_line_4: "",
        postcode: "",
      },
      forecast_commission: {
        sc_forecast_or_amended_annual_consumption: null,
        sc_corecast_or_amended_total_commission: 0.0,
        u4b_uplift: 0,
        kva: 0.0,
        day_consumption: null,
        day_uplift: null,
        night_consumption: null,
        night_uplift: null,
        weekend_consumption: null,
        weekend_uplift: null,
        uplift_standing_charge: null,
      },
      billing_address_same_as: ""
    });
    // <script setup>
    const handleEmailClick = (email) => {
      // Open email client
      window.location.href = `mailto:${email}`;

      // OR do something custom like showing a modal, copying, etc.
    };
    const setTime = async () => {
      if (!formData.value.next_update_latest_date) {
        formData.value.next_update_latest_time = ``;
        timeValue.value = null;
      }
      await updateOpportunity()
    }

    const onPickerOpen = (open) => {
      if (open) {
        sanitizeInput();
      }
    };
    const sanitizeInput = () => {
      const inputEl = document.querySelector(".ant-picker-input input");
      if (inputEl) {
        inputEl.addEventListener("input", (event) => {
          const sanitizedValue = event.target.value.replace(/[^0-9:]/g, "");
          event.target.value = sanitizedValue;
        });
      }
    };

    const selectOption = (option) => {
      selectedOption.value = selectedOption.value === option ? null : option;
      formData.value.billing_address_same_as = selectedOption.value;
      if (selectedOption.value === 'supply') {
        formData.value.billing_address.address_line_1 = formData.value.supply_address.building_name;
        formData.value.billing_address.address_line_2 = formData.value.supply_address.street;
        formData.value.billing_address.address_line_3 = formData.value.supply_address.city;
        formData.value.billing_address.address_line_4 = formData.value.supply_address.county;
        formData.value.billing_address.postcode = formData.value.supply_address.postcode;
      } else if (selectedOption.value === 'organisation') {
        formData.value.billing_address.address_line_1 = org_details.value.address;
        formData.value.billing_address.address_line_2 = org_details.value.city;
        formData.value.billing_address.address_line_3 = org_details.value.state;
        formData.value.billing_address.address_line_4 = org_details.value.address_line_4;
        formData.value.billing_address.postcode = org_details.value.postcode;
      }
      else {
        formData.value.billing_address.address_line_1 = billingAddress.address_line_1;
        formData.value.billing_address.address_line_2 = billingAddress.address_line_2;
        formData.value.billing_address.address_line_3 = billingAddress.address_line_3;
        formData.value.billing_address.address_line_4 = billingAddress.address_line_4;
        formData.value.billing_address.postcode = billingAddress.postcode;
      }
    }

    const handleChange = () => {
      formData.value.billing_address_same_as = "";
      selectedOption.value = ""
    }

    const fetchOppData = async (id) => {
      try {
        const data = await store.dispatch("opportunity/fetchOpportunity", id);
        if (!data) {
          showFallback.value = true;
          return
        }
        org_id.value = data.organization_id;
        terId.value = data.territory_id;
        oppId.value = data.id;

        oppData.value = data;
        logs.value = data.opportunities_logs;
        org_details.value = data.organization;
        companyType.value = data.organization.type;
        orgPersonsDetails.value = data.organization_person;
        billingAddress = { ...data.billing_address };
        formData.value.billing_address_same_as = data.billing_address_same_as;
        selectedOption.value = data.billing_address_same_as;
        // isValidate.value = data.is_valid;
        piplelineType.value = data.form_validation;
        pipleline_type.value = data.pipeline_type;
        productFor.value = data.main_production_service;
        complete_address.value = data.complete_address;
        quoteCount.value = data.quotes_count;
        last_dialed_at.value = data.last_dialed_at;
        last_no_answer_at.value = data.last_no_answer_at;
        adjustDialValue.value = data.number_of_dials;
        adjustValue.value = data.number_of_no_answers;
        // created_updated.value = data.
        if (data.next_update_latest_time) {
          const [hours, minutes] = data.next_update_latest_time.split(":");
          formData.value.next_update_latest_time = `${hours}:${minutes}:00`
          const timeString = `${hours}:${minutes}`; // HH:mm format
          const dayjsObject = dayjs(timeString, "HH:mm");
          timeValue.value = dayjsObject
        }
        else {
          timeValue.value = null
        }
        Object.assign(formData.value, data);
        Object.assign(
          formData.value.forecast_commission,
          data.forecast_commission
        );
        if (!formData.value.main_production_service) {
          if (formData.value.mpan_top || formData.value.mpan_bottom) {
            formData.value.main_production_service = 'elec'
          } else if (formData.value.mpr) {
            formData.value.main_production_service = 'gas'
          }
        }
        if (data.organization.hasOwnProperty("tps")) {
          isTps.value = true;
          formData.value.tps = data?.organization?.tps ? data?.organization?.tps : "N/A"
        } else {
          isTps.value = false;
        }
        if (data.date_disabled === 1) {
          isDateEditable.value = false;
        } else {
          isDateEditable.value = true;
        }
        // if (data.pipeline_type === "contract_won") {
        //   isShowWon.value = true;
        // } else {
        //   isShowWon.value = false;
        // }
        // if (data.pipeline_type === "closed_meter_op") {
        //   isLost.value = true;
        // } else {
        //   isLost.value = false;
        // }

        if (data.next_update_latest_date) {
          formData.value.next_update_latest_date = new Date(
            data.next_update_latest_date
          );
        }
        if (data.date_of_sale) {
          formData.value.date_of_sale = new Date(data.date_of_sale);
        }
        if (data.contract_end_date) {
          formData.value.contract_end_date = new Date(data.contract_end_date);
        }
        contract_end_date.value = formData.value.contract_end_date ?? null;
        setStartDateFromEndDate();

        // if (data.contract_end_date) {
        //   const contractEndDate = new Date(data.contract_end_date);
        //   formData.value.contract_end_date = contractEndDate;

        //   // Get the date 365 days from today
        //   const today = new Date();
        //   const oneYearBefore = new Date();
        //   oneYearBefore.setDate(today.getDate() - 365);

        //   // Check if contract_end_date is beyond the 365-day window
        //   if (contractEndDate < oneYearBefore) {
        //     showFRS.value = true;
        //   }
        // }

        if (data.cot_date) {
          formData.value.cot_date = new Date(data.cot_date);
        }
        if (data.pipeline_updated_at) {
          // const dateOnly = data.pipeline_updated_at.split(' ')[0];
          formData.value.pipeline_updated_at = new Date(data.pipeline_updated_at);
        }
        // Start date is derived from CED + 1 day (set in setStartDateFromEndDate above)
        supplier_id.value = data.supplier_id;
        formData.value.content = "";
        fileData.value = data.opportunities_docs;
        // originalForm.value = structuredClone(formData.value);
      } catch (error) {
        console.error("Error fetching organization data:", error);
      }
    };
    const myChangeEvent = (event, role) => {
      if (event.id === 'null') {
        if (role === 'current') {
          supplier_id.value = null;
          formData.value.supplier_id = null;
        } else if (role === 'new') {
          formData.value.new_supplier_id = null;
        }
      }
      else {
        if (role === 'current') {
          supplier_id.value = formData.value.supplier_id;
        }
      }
    }

    const clearDate = () => {
      if (formData.value.contract_start_date) {
        contract_start_date.value = formData.value.contract_start_date;
      }
      else {
        contract_start_date.value = null;
      }
    };

    const setStartDateFromEndDate = () => {
      if (formData.value.contract_end_date) {
        const end = new Date(formData.value.contract_end_date);
        end.setDate(end.getDate() + 1);
        formData.value.contract_start_date = end;
        contract_start_date.value = end;
      } else {
        formData.value.contract_start_date = null;
        contract_start_date.value = null;
      }
    };

    const clearEndDate = () => {
      if (formData.value.contract_end_date) {
        contract_end_date.value = formData.value.contract_end_date;
        setStartDateFromEndDate();
      } else {
        contract_end_date.value = null;
        formData.value.contract_start_date = null;
        contract_start_date.value = null;
      }
    };
    // Utility functions for formatting and removing formatting
    const formatNumber = (value) => {
      const number = parseFloat(value);
      if (!isNaN(number)) {
        return number.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return "0.00";
    };

    const removeFormatting = (value) => {
      const numberValue = value.replace(/,/g, ""); // Remove commas
      return parseFloat(numberValue) || 0;
    };
    // Function to handle change
    const fetchWinProb = async () => {
       formData.value.pipeline_updated_at = new Date();

      const selectedPipelineLevelId = formData.value.pipeline_level;
      const selectedOppId = formData.value.id;

      const data = await store.dispatch("opportunity/fetchWinProb", {
        pipelineID: selectedPipelineLevelId,
        selectedOppId: selectedOppId,
      });
      piplelineType.value = data?.data?.form_validation
      pipeline_type.value = data?.data?.pipeline_type
      // if (data?.data?.pipeline_type === "contract_won") {
      //   isShowWon.value = true;
      // } else {
      //   isShowWon.value = false;
      // }
      if (data?.data?.pipeline_type === "closed_meter_op") {
        // isLost.value = true;
        const modal = new Modal(document.getElementById("confirm_opp_modal"));
        modal.show();
      } else {
        // isLost.value = false;
      }
      if (data && data.data) {
        // formData.value.win_probability = data.data.win_prob_percentage;
        // formData.value.next_update_latest_date = new Date(
        //   data.data.next_update_latest_date
        // );
        // if (data.data.date_disabled === 1) {
        //   isDateEditable.value = false;
        // } else {
        //   isDateEditable.value = true;
        // }
      }
    };

    const deadLead = async (name) => {
      // if (name === 'Reopen') {
      //   formData.value.pipeline_level = oppData.value.pipeline_level;
      //   formData.value.comment = oppData.value.comment;
      // } else {
      //   formData.value.date_of_sale = new Date(oppData.value.date_of_sale);
      //   formData.value.reason = oppData.value.reason;
      //   formData.value.competitor = oppData.value.competitor;
      //   formData.value.explanation = oppData.value.explanation;

      // }
      const modal = new Modal(document.getElementById("confirm_opp_modal"));
      modal.show();
    };

    const createFRS = () => {
      // formData.value.contract_end_date = oppData.value.contract_end_date ? new Date(oppData.value.contract_end_date) : null;
      // formData.value.supplier_id = oppData.value.supplier_id;
      // formData.value.comment = oppData.value.comment;
      const modal = new Modal(document.getElementById("confirm_frs_modal"));
      modal.show();
    }

    const createHOTKEY = () => {
      // formData.value.contract_end_date = oppData.value.contract_end_date ? new Date(oppData.value.contract_end_date) : null;
      // formData.value.supplier_id = oppData.value.supplier_id;
      // formData.value.comment = oppData.value.comment;
      const modal = new Modal(document.getElementById("confirm_hotkey_modal"));
      modal.show();
    }

    const createOutbound = () => {
      const modal = new Modal(document.getElementById("confirm_outbound_modal"));
      modal.show();
    }

    const refreshOpportunityAfterCreate = async () => {
      const currentOppId = formData.value.id || oppId.value || route.params.id;
      if (currentOppId) {
        await fetchOppData(currentOppId);
      }
    };

    // Function to add days or months
    const addToDate = (field, type, value) => {
      // Check if the field is valid
      if (["date_of_sale", "next_update_latest_date"].includes(field)) {
        const numericValue = parseInt(value); // Convert the string value to an integer

        // If value is 0, set the date to today's date
        if (numericValue === 0) {
          formData.value[field] = new Date(); // Set to today's date
        } else {
          let currentDate;

          // Ensure the base date is correctly determined
          if (field === "next_update_latest_date") {
            currentDate = new Date(); // Start with today's date
          } else {
            currentDate = formData.value[field] ? new Date(formData.value[field]) : new Date();
          }

          // Add days or months based on the type
          if (type === "days") {
            currentDate.setDate(currentDate.getDate() + numericValue); // Add days
          } else if (type === "months") {
            currentDate.setMonth(currentDate.getMonth() + numericValue); // Add months
            
            // Check if the calculated date falls on a weekend (Saturday = 6, Sunday = 0)
            const dayOfWeek = currentDate.getDay();
            if (dayOfWeek === 0) { // Sunday
              currentDate.setDate(currentDate.getDate() + 1); // Move to Monday
            } else if (dayOfWeek === 6) { // Saturday
              currentDate.setDate(currentDate.getDate() + 2); // Move to Monday
            }
          }

          // Update the corresponding field in formData
          formData.value[field] = new Date(currentDate);
        }
        if (field === "next_update_latest_date") {
          updateOpportunity(); // Call your custom function
        }
      }
    };

    const getFutureDate = (term, formate) => {
      const future = new Date(currtDate.value)
      if (formate === 'day') {
        future.setDate(future.getDate() + Number(term))
      } else {
        future.setMonth(future.getMonth() + Number(term))
        const dayOfWeek = future.getDay();
        if (dayOfWeek === 0) { // Sunday
          future.setDate(future.getDate() + 1); // Move to Monday
        } else if (dayOfWeek === 6) { // Saturday
          future.setDate(future.getDate() + 2); // Move to Monday
        }
      }
      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

      const year = future.getFullYear()
      const month = String(future.getMonth() + 1).padStart(2, '0') // months are 0-based
      const date = String(future.getDate()).padStart(2, '0')
      const dayName = dayNames[future.getDay()]

      return `${date}/${month}/${year}(${dayName})`
    }

    const getQuote = async () => {
      if (
        formData.value.main_production_service === null || formData.value.main_production_service === '' ||
        formData.value.supplier_id === null || formData.value.supplier_id === '' ||
        // formData.value.contract_start_date === null || formData.value.contract_start_date === '' ||
        // formData.value.contract_end_date === null || formData.value.contract_end_date === '' ||
        formData.value.supply_address.building_name === null || formData.value.supply_address.building_name === '' ||
        formData.value.supply_address.street === null || formData.value.supply_address.street === '' ||
        formData.value.supply_address.city === null || formData.value.supply_address.city === '' ||
        formData.value.supply_address.county === null || formData.value.supply_address.county === '' ||
        formData.value.sales_contact === null || formData.value.sales_contact === '' ||
        formData.value.sales_responsible === null || formData.value.sales_responsible === '' ||
        formData.value.supply_address.postcode === null || formData.value.supply_address.postcode === ''
        || formData.value.forecast_commission.sc_forecast_or_amended_annual_consumption === '0.00'
      ) {
        isNotValid.value = true;
        return;
      } else {
        if (formData.value.main_production_service === 'gas' && (formData.value.mpr === "" || formData.value.mpr === null)) {
          isNotValid.value = true;
        }
        else if (formData.value.main_production_service === 'elec' && (formData.value.mpan_top === "" || formData.value.mpan_top) === null && (formData.value.mpan_bottom === "" || formData.value.mpan_bottom === null)) {
          isNotValid.value = true;
        }
        else {
          isNotValid.value = false;
          await updateOpportunity();
          if (apiErrors.value.length === 0)
            router.push({
              path: "/quoting",
              query: {
                opp_Id: oppId.value, ter_Id: terId.value,
                org_Id: org_id.value, for: productFor.value
              },
            });
        }

      }
    }
    const updateOpportunity = async () => {
      if (
        formData.value.pipeline_level &&
        formData.value.main_production_service &&
        (
          formData.value.mpr ||
          (
            formData.value.mpan_top &&
            formData.value.mpan_bottom
          )
        ) &&
        formData.value.supplier_id &&
        formData.value.contract_start_date &&
        formData.value.contract_end_date &&
        formData.value.supply_address.building_name &&
        formData.value.supply_address.street &&
        formData.value.supply_address.city &&
        formData.value.supply_address.county &&
        formData.value.sales_contact &&
        formData.value.sales_responsible &&
        formData.value.supply_address.postcode
        && formData.value.forecast_commission.sc_forecast_or_amended_annual_consumption
      ) {
        // isNotValid.value = true;
        formData.value.is_valid = 1;
      } else {
        formData.value.is_valid = 0;
      }
      // formData.value.is_valid = 1;
      productFor.value = formData.value.main_production_service;
      const next_update_latest = changeFormate(formData.value.next_update_latest_date)
      const date_of_sale = changeFormate(formData.value.date_of_sale)
      const contract_end_date = changeFormate(formData.value.contract_end_date)
      const contract_start_date = changeFormate(formData.value.contract_start_date)
      const cot_date = changeFormate(formData.value.cot_date)
      const pipeline_updated_at = changeFormate(formData.value.pipeline_updated_at);
      const sc_forecast_or_amended_annual_consumption = formData.value.forecast_commission.sc_forecast_or_amended_annual_consumption || '0.00'
      // const next_update_latest =  changeFormate(formData.value.next_update_latest_date
      if (formData.value.main_production_service === 'gas') {
        formData.value.mpan_top = null;
        formData.value.mpan_bottom = null;
      } else {
        formData.value.mpr = null;
      }
      const response = await store.dispatch(
        "opportunity/updateOpportunity",
        {
          ...formData.value,
          next_update_latest_date: next_update_latest,
          date_of_sale: date_of_sale,
          contract_end_date: contract_end_date,
          contract_start_date: contract_start_date,
          cot_date: cot_date,
          forecast_commission: { ...formData.value.forecast_commission, sc_forecast_or_amended_annual_consumption: sc_forecast_or_amended_annual_consumption },
          columnsOrder: defaultFields.value,
          pipeline_updated_at: pipeline_updated_at,
        }
      );
      if (response.status) {
        // showLeaveModal.value = false;
        // hasUnsavedChanges.value = false;
        await fetchOppData(formData.value.id);
        loaRefreshKey.value++;
        // router.push("/crm/meter-opportunities-list");
        document.getElementById("close-btn").click();
        apiErrors.value = []
        if (pipeline_type.value === 'contract_won') {
          const url = router.resolve({
            path: `/crm/edit-contract/${response?.data?.contract_id}`
          }).href;

          window.open(url, "_blank");
        }
      } else {
        // router.push("/crm/meter-opportunities-kanban");
        apiErrors.value = response.errors
      }
      // }
    };
    const handleCancel = () => {
      const query = route.query.add;
      if (query === "org-details") {
        router.push({
          path: "/crm/organisation-details",
          query: {
            org_Id: org_id.value,
            ter_Id: terId.value,
            opp_Id: oppId.value,
            for: 'opportunities'
          },
        });
      } else if (query === "dashboard") {
        router.push("/dashboard");
      } else {
        if (!isKanban.value) {
          router.push("/crm/meter-opportunities-list");
        } else {
          router.push("/crm/meter-opportunities-kanban");
        }
      }
    };

    const cooldownTime = 3 * 60 * 60 * 1000;
    const checkCooldown = () => {
      // const currentTime = new Date().getTime()
      // const currentTime = new Date(new Date().toUTCString()).getTime() - 5.5 * 60 * 60 * 1000;
      const ukDate = new Date().toLocaleString("en-GB", { timeZone: "Europe/London" });
      const currentTime = new Date(ukDate.replace(/(\d+)\/(\d+)\/(\d+),/, "$3-$2-$1")).getTime();
      disabledDail.value = currentTime - new Date(last_dialed_at.value).getTime() > cooldownTime;
      disabledAnswer.value = currentTime - new Date(last_no_answer_at.value).getTime() > cooldownTime;
      if (disabledDail.value && disabledAnswer.value) {
        clearInterval(intervalId);
      }
    }

    const onChange = async () => {
      if (fileInput.value && fileInput.value.files) {
        files.value = fileInput.value.files;
        // const opp_Id = route.query.opp_Id;
        const response = await store.dispatch("opportunity/uploadFile", {
          type: 'opportunity',
          file: files.value,
          id: oppId.value
        });
        if (response.status) {
          await fetchOppData(oppId.value)
        }
      }
    };

    const dragover = (e) => {
      e.preventDefault();
      isDragging.value = true;
    };

    const dragleave = () => {
      isDragging.value = false;
    };

    const drop = (e) => {
      e.preventDefault();
      if (fileInput.value) {
        fileInput.value.files = e.dataTransfer.files;
        onChange();
      }
      isDragging.value = false;
    };

    const deleteFile = async (id) => {
      const response = await store.dispatch("opportunity/deleteFile", id)
      if (response.status) {
        // const opp_Id = route.query.opp_Id;
        await fetchOppData(oppId.value)
      }
    }


    // State tracking
    const renameStates = ref({})
    const renameInputs = ref({})

    // Methods
    const showRenameField = (docName, fileId) => {
      renameStates.value[fileId] = true
      renameInputs.value[fileId] = docName
    }

    const cancelRename = (fileId) => {
      renameStates.value[fileId] = false
    }

    const renameDoc = async (fileId, doc_type) => {
      const newName = renameInputs.value[fileId]
      if (newName) {
        const payload = {
          doc_id: fileId,
          // doc_name: `${newName}.${doc_type}`
          doc_name: newName
        }
        const response = await store.dispatch("opportunity/renameFile", payload)
        if (response.status) {
          await fetchOppData(oppId.value)
          renameStates.value[fileId] = false
        }
      }
    }

    const viewFile = (url) => {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.split('/').pop();
      link.target = '_blank';
      link.click();
    };

    const fetchOptions = async () => {
      try {
        const response = await apiClient.get("settings/organisation-person");
        settingOptions.value = response.data.data.dropdowns;
      } catch (error) {
        console.error("Error fetching options data:", error);
      }
    };
    const downloadFile = async (file) => {

      try {
        window.open(file.file_path, "_blank");
      } catch (error) {
        console.error('Error downloading the file:', error);
      }

    };
    const formatDate = (date) => {
      if (date) {
        const [year, month, day] = date.split('T')[0].split('-');
        return `${day}-${month}-${year}`;
      }
    };

    const handleTimeChange = (value) => {
      if (value) {
        // Format the Day.js object to a string (HH:mm)
        const hour = value.hour();
        const minutes = value.minute();
        const formattedTime = value?.format('HH:mm');

        // Only allow hours between 8 and 18
        if (hour < 8 || (hour >= 18 && minutes > 0)) {
          if (formData.value.next_update_latest_time) {
            const [hours, minutes] = formData.value.next_update_latest_time.split(":");
            const timeString = `${hours}:${minutes}`; // HH:mm format
            const dayjsObject = dayjs(timeString, "HH:mm");
            timeValue.value = dayjsObject
            return;
          } else {
            timeValue.value = null
          }
        }
        if (formattedTime) {
          formData.value.next_update_latest_time = `${formattedTime}:00`;
        } else {
          formData.value.next_update_latest_time = `00:00:00`;
        }
      }


    };

    const disableHours = () => {
      // Disables hours before 8 AM and after 6 PM
      const disabled = [];
      for (let i = 0; i < 24; i++) {
        if (i < 8 || i > 18) {
          disabled.push(i);
        }
      }
      return disabled;
    };
    const fetchOrgPerson = async (id) => {
      try {
        const totalPersons = await store.dispatch('opportunity/fetchPersons', id);
        orgPersons.value = totalPersons;

        // Automatically select the first contact if only one is available
        // if (orgPersons.value.length === 1) {
        //   formData.value.sales_contact = orgPersons.value[0].id;
        // }
      } catch (error) {
        console.error('Error fetching persons:', error);
      }
    };

    const adjustDate = async (amount, event) => {
      event.preventDefault(); // Prevent default behavior
      // const opp_Id = route.query.opp_Id;
      const payload = {
        data: {
          field: 'number_of_no_answers',
        },
        opp_id: oppId.value
      }
      const response = await store.dispatch("opportunity/updateCounter", payload)
      if (response.status) {
        // await fetchOppData(oppId.value);
        adjustValue.value += amount;
        clearInterval(intervalId);
        intervalId = setInterval(checkCooldown, 1000); // Run every second
      }

    };

    const adjustDateDials = async (amount, event) => {
      event.preventDefault(); // Prevent default behavior
      // const opp_Id = route.query.opp_Id;
      const payload = {
        data: {
          field: 'number_of_dials',
        },
        opp_id: oppId.value
      }
      const response = await store.dispatch("opportunity/updateCounter", payload)
      if (response.status) {
        // await fetchOppData(oppId.value);
        adjustDialValue.value += amount;
        clearInterval(intervalId);
        intervalId = setInterval(checkCooldown, 1000); // Run every second
      }
    };

    const confirm_change = async (name) => {
      // const oppId = route.query.opp_Id;
      if (name === 'Reopen') {
        await updateOpportunity();
      } else {
        try {
          const response = await apiClient.post(`/opportunity/update/${oppId.value}?dead_lead=1`, formData.value);
          if (response?.data?.status) {
            message.success(response?.data?.message)
            // await fetchOppData(oppId);
            // checkCooldown(); // Run initially
            // intervalId = setInterval(checkCooldown, 1000); // Run every second 

            document.getElementById("close-btn").click();
            router.push('/crm/meter-opportunities-kanban')

          } else {
            message.error(response?.data?.message)
          }
        } catch (error) {
          message.error(error?.response?.data?.message)
        }
      }

    };
    const cancel_change = async () => {
      formData.value.pipeline_level = oppData.value.pipeline_level;
      formData.value.comment = oppData.value.comment;
      // formData.value.date_of_sale = oppData.value.date_of_sale ? new Date(oppData.value.date_of_sale) : null;
      formData.value.reason = oppData.value.reason;
      formData.value.competitor = oppData.value.competitor;
      formData.value.explanation = oppData.value.explanation;
      document.getElementById("close-btn").click();
    };

    const searchMpan = async (mpan_bottom) => {
      if (mpan_bottom) {
        const paramsData = {
          search_type: 'mpan', // Pass selected search type
          search_value: mpan_bottom,
          electra_link_set: electra_link_set.value
        };
        // Dispatch the Vuex action with paramsData
        const response = await store.dispatch(
          "price/fetchLookupData",
          paramsData
        );

        if (response) {
          electricData.value = response;
          isPowwrData.value = false;
          electricDataRawPowwr.value = null;
          isVisible.value = true;
        }
      }
    };

    const searchPowwrMpan = async (mpan_bottom) => {
      if (mpan_bottom) {
        try {
          const response = await store.dispatch(
            "price/fetchPowwrMpanSearch",
            mpan_bottom
          );

          if (response && response.mapped !== undefined) {
            electricData.value = response.mapped;
            electricDataRawPowwr.value = response.raw ?? null;
            isPowwrData.value = true;
            isVisible.value = true;
          }
        } catch (err) {
          // Error already shown by store action
        }
      }
    };

    onMounted(async () => {
      // originalForm.value = structuredClone(formData.value);
      fetchColumns();
      // const opp_Id = route.query.opp_Id;
      // const organisation_id = route.query.org_Id;
      // const territory_id = route.query.ter_Id;
      if (oppNumber.value) {
        await fetchOppData(oppNumber.value);
        checkCooldown(); // Run initially
        intervalId = setInterval(checkCooldown, 1000); // Run every second
      }
      if (org_id.value) {
        //  const orgPerson = store.dispatch("opportunity/fetchPersons", organisation_id);
        fetchOrgPerson(org_id.value)
        // if (orgPersons.value.length === 1) {
        //   formData.value.sales_contact = orgPersons.value[0].id;
        // }
      }
      fetchOptions();
      store.dispatch("organisation/fetchTerritoryCompanyUsers", terId.value);
      // await store.dispatch("opportunity/fetchCMUsers", territory_id);
      store.dispatch("opportunity/fetchPipelines");
      // const data = await store.dispatch('opportunity/fetchOpportunityOptions');
      // supplierOptions.value = [
      //   { id: 'null', text: 'Select....', original: null },
      //   ...data?.supplier?.map(item => ({
      //     id: item.id,
      //     text: item.name,
      //     original: item,
      //   }))
      // ];
    });

    onUnmounted(() => {
      clearInterval(intervalId); // Clean up when the component is unmounted
      fields.value = JSON.parse(localStorage.getItem("fieldsOrder")) || defaultFields;
    });
    const defaultFields = ref([
      { key: "sales_responsible", label: "Sales Responsible", required: true },
      { key: "referred_by", label: "Referred By", required: false },
      { key: "opp_type", label: "Opp Type", required: false },
      { key: "created_from_contract_number", label: "Created From Contract Number", required: false },
      { key: "main_production_service", label: "Main Product/Service", required: true },
      { key: "pipeline_level", label: "Pipeline Level", required: true },
      { key: 'pipeline_updated_at', label: 'Status Update Date', required: true }
    ]);

    const fetchColumns = async () => {
      const res = await store.dispatch("opportunity/getColumnsData", 'opportunities');
      if (res.data && Object.keys(res.data).length > 0) {
        const fetchedFields = res.data.fields_json || [];
        const fetchedKeys = new Set(fetchedFields.map(field => field.key));
        const newFields = defaultFields.value.filter(field => !fetchedKeys.has(field.key));
        const mergedFields = [...fetchedFields, ...newFields];
        defaultFields.value = mergedFields;
        fields.value = mergedFields;
      }
    };


    let draggedIndex = null;

    // Load saved column order or use default
    const fields = ref(defaultFields);
    // Dragging functions
    const dragStart = (event, index) => {
      draggedIndex = index;
      event.dataTransfer.effectAllowed = "move";
    };

    const dragEnd = (event, dropIndex) => {
      if (draggedIndex !== null && draggedIndex !== dropIndex) {
        // Swap the fields
        const temp = fields.value[draggedIndex];
        fields.value[draggedIndex] = fields.value[dropIndex];
        fields.value[dropIndex] = temp;
      }
      saveFieldOrder();
      draggedIndex = null;
    };

    const allowDrop = (event) => {
      event.preventDefault();
    };

    // Save order to localStorage
    const saveFieldOrder = async () => {
      // updateOpportunity()
      const payload = {
        form_key: 'opportunities',
        fields_json: defaultFields.value
      }
      const response = await store.dispatch("opportunity/changeColumns", payload)
      // localStorage.setItem("fieldsOrder", JSON.stringify(fields.value));

    };

    const totalConsumption = () => {
      const night_consumption = parseInt(formData.value.forecast_commission.night_consumption) || 0;
      const weekend_consumption = parseInt(formData.value.forecast_commission.weekend_consumption) || 0;
      const day_consumption = parseInt(formData.value.forecast_commission.day_consumption) || 0;

      // Ensure that we only consider the new values instead of accumulating over previous sums
      formData.value.forecast_commission.sc_forecast_or_amended_annual_consumption =
        Number(night_consumption + weekend_consumption + day_consumption);
    };

    const clickOutside = () => {
      formData.value.pipeline_level = oppData.value.pipeline_level;
      formData.value.comment = oppData.value.comment;
      // formData.value.date_of_sale = oppData.value.date_of_sale ? new Date(oppData.value.date_of_sale) : null;
      formData.value.reason = oppData.value.reason;
      formData.value.competitor = oppData.value.competitor;
      formData.value.explanation = oppData.value.explanation;
    };

    const handleU4vUplift = () => {
      if (formData.value.forecast_commission.u4b_uplift === '') {
        formData.value.forecast_commission.u4b_uplift = 0
      }
    }

    onMounted(() => {
      if (closedMeterOpp.value) {
        closedMeterOpp.value.addEventListener("hidden.bs.modal", clickOutside);
      }
    });
    const fetchOptionsData = async () => {
      const params = {
        product_service: formData.value.main_production_service,
      };

      const data = await store.dispatch(
        "opportunity/fetchOpportunityOptions",
        params
      );

      supplierOptions.value = [
        { id: null, text: "Select....", original: null },
        ...data.supplier.map(item => ({
          id: item.id,
          text: item.name,
          original: item,
        })),
      ];
    };
    watch(
      () => formData.value.main_production_service,
      async (newValue, oldValue) => {
        if (newValue !== oldValue && oldValue !== null) {
          formData.value.supplier_id = null;
        }

        await fetchOptionsData();
      },
      {
        immediate: true,
      }
    );
    // Watch for changes in sales_contact and pipelineType
    watch(
      () => formData.value.sales_contact,
      (newSalesContact) => {
        if (
          pipeline_type.value === 'contract_won' &&
          newSalesContact !== null &&
          newSalesContact !== undefined
        ) {
          const person = orgPersons.value.find((p) => p.id === newSalesContact);
          if (person && !person.email) {
            isShowEmailPopup.value = true;
          } else {
            isShowEmailPopup.value = false;
          }
        } else {
          isShowEmailPopup.value = false;
        }
      },
      { immediate: true } // Trigger the watch immediately on component load
    );

    // Optional: Also watch pipelineType if that can change
    watch(
      () => pipeline_type.value,
      (newType) => {
        if (
          newType === 'contract_won' &&
          formData.value.sales_contact !== null &&
          formData.value.sales_contact !== undefined
        ) {
          const person = orgPersons.value.find(
            (p) => p.id === formData.value.sales_contact
          );
          if (person && !person.email) {
            isShowEmailPopup.value = true;
          } else {
            isShowEmailPopup.value = false;
          }
        } else {
          isShowEmailPopup.value = false;
        }
      }
    );
    // Watch for changes and update localStorage
    // watch(fields, saveFieldOrder, { deep: true });

    // Router navigation guard
    // onBeforeRouteLeave((to, from, next) => {
    //   hasUnsavedChanges.value = !isEqual(originalForm.value, formData.value)
    //   if (hasUnsavedChanges.value) {
    //     showLeaveModal.value = true;
    //     pendingRoute = to;
    //     next(false);
    //   } else {
    //     next();
    //   }
    // });

    // const confirmLeave = () => {
    //   showLeaveModal.value = false;
    //   hasUnsavedChanges.value = false;
    //   formData.value = structuredClone(originalForm.value);
    //   if (pendingRoute) {
    //     router.push(pendingRoute); // Manually navigate
    //     pendingRoute = null;
    //   }
    // };

    // const cancelLeave = () => {
    //   showLeaveModal.value = false;
    //   pendingRoute = null;
    // };

    watch(() => route.params.id, async () => {
      const opp_Id = route.params.id;
      if (opp_Id) {
        await fetchOppData(opp_Id);
        checkCooldown(); // Run initially
        intervalId = setInterval(checkCooldown, 1000);
      }
    });
    return {
      fetchOptionsData,
      oppNumber,
      fields,
      saveFieldOrder,
      allowDrop,
      dragEnd,
      dragStart,
      defaultFields,
      quoteCount,
      isNotValid,
      productFor,
      oppId,
      companyType,
      fetchOrgPerson,
      schema,
      formData,
      org_id,
      updateOpportunity,
      handleCancel,
      pipelineLevels,
      options,
      supplierOptions,
      orgPersons,
      opportunityData,
      org_details,
      complete_address,
      saleResponsibleOptions,
      showFallback,
      // cmResponsibleOptions,
      addDays,
      addMonths,
      addToDate,
      apiErrors,
      terId,
      logs,
      formattedNextUpdateLatest,
      fetchWinProb,
      isKanban,
      formattedData,
      formatNumber,
      updateFormData,
      removeFormatting,
      isDateEditable,
      // isShowWon,
      myChangeEvent,
      // isLost,
      changeFormate,
      setTime,
      // created_updated,
      isDragging,
      files,
      fileInput,
      onChange,
      dragover,
      dragleave,
      drop,
      fileData,
      deleteFile,
      viewFile,
      downloadFile,
      formatDate,
      showAllFiles,
      orgPersonsDetails,
      displayedFiles,
      toggleViewMore,
      supplier_id,
      contract_start_date,
      contract_end_date,
      clearEndDate,
      handleEmailClick,
      clearDate,
      getQuote,
      isTps,
      settingOptions,
      fetchOptions,
      timeValue,
      handleTimeChange,
      onPickerOpen,
      piplelineType,
      pipleline_type,
      selectedOption,
      selectOption,
      handleChange,
      openModal,
      selectedLabel,
      selectedPostcode,
      closeModal,
      isModalVisible,
      isVisible,
      adjustDate,
      adjustValue,
      adjustDialValue,
      cancel_change,
      confirm_change,
      adjustDateDials,
      last_dialed_at,
      last_no_answer_at,
      disabledDail,
      disabledAnswer,
      checkCooldown,
      deadLead,
      oppData,
      // showFRS,
      createFRS,
      createHOTKEY,
      createOutbound,
      refreshOpportunityAfterCreate,
      searchMpan,
      searchPowwrMpan,
      electricData,
      electricDataRawPowwr,
      isPowwrData,
      electra_link_set,
      closedMeterOpp,
      supplierName,
      totalConsumption,
      pipeline_type,
      permissions,
      pipelineLevelsForOpen,
      disableHours,
      handleU4vUplift,
      user,
      renameDoc,
      showRename,
      renameInput,
      showRenameField,
      fileId,
      cancelRename,
      renameStates,
      renameInputs,
      getFutureDate,
      currtDate,
      confirm_email_change,
      cancel_email_change,
      email,
      isShowEmailPopup,
      loaRefreshKey,
      // confirmLeave,
      // cancelLeave,
      // originalForm,
      // hasUnsavedChanges,
      // showLeaveModal
    };
  },
};
</script>

<style lang="scss" scoped>
.number_field {
  border-color: #E8E8E8;
  color: #6F6F6F;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  min-height: 32px;
  border: 2px solid #E8E8E8;
  width: 100%;
}

.checkbox-size {
  transform: scale(1.5);
  /* Adjust the scale factor as needed */
  margin-right: 10px;
}

.col-form-label {
  font-size: 13px;
}

.website {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #00918e;
  color: #fff;
}

.add-cursor {
  cursor: pointer;
  font-weight: 400;
}

.disabled {
  background-color: #f6f6f6;
}

.dropzone-container {
  text-align: center;
  padding: 1rem;
  margin: 1rem 5px;
  background: #f7fafc;
  border: 2px dotted#e2e8f0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 16px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.table {
  border-color: rgb(225, 225, 225);
  word-wrap: break-word;
}

.table th,
.table td {
  padding: 0;
  padding-bottom: 5px;
  text-align: center;
  word-wrap: break-word;
}

.icon-size {
  font-size: 1.5rem;
  cursor: pointer;
}

.add-x-scroll {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 0;
  -webkit-overflow-scrolling: touch;
}

.truncate-doc-name {
  width: 200px;
}

.logs_Section {
  max-height: 320px;
  overflow-x: hidden;
}

.logs_Section.resizable {
  resize: vertical;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100px;
  max-height: 80vh;
  /* optional limit */
  border: 1px solid #ccc;
  /* so users see where to drag */
  padding: 5px;
}

.icon-form .ant-space .ant-space-item .ant-picker {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-color: #E8E8E8;
  color: #6F6F6F;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  min-height: 42px;
}

.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-content .ant-picker-time-panel-column::after {
  display: block;
  height: 0px !important;
  content: "";
}

.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-footer .ant-picker-ranges .ant-picker-now {
  display: none !important;
}


.draggable-field {
  cursor: grab;
  transition: all 0.2s ease-in-out;
}

.draggable-field:active {
  cursor: grabbing;
  background: #f8f9fa;
}

.cursor-pointer {
  cursor: pointer !important;
}

.modal-backdrop {
  position: fixed;
  // inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  opacity: 1;
}

.modal-dialog {
  // background: white;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
}

.modal-body {
  padding: 1rem;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
.disabledopp{
  background-color: #e9ecef !important;
}
</style>
